module.exports = __webpack_public_path__ + "img/cloth_g3_shirt_14.4924f622.svg";